import type React from 'react';

import { TablePagination, type TablePaginationProps } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { useStyles } from './styles';
import TablePaginationActions from './TablePaginationActions';

type TPaginationClasses = 'paginationCaption' | 'menuItem' | 'toolbar' | 'select' | 'action';

type PaginationProps = Pick<
  TablePaginationProps,
  | 'classes'
  | 'ActionsComponent'
  | 'count'
  | 'rowsPerPage'
  | 'page'
  | 'onPageChange'
  | 'onRowsPerPageChange'
  | 'labelDisplayedRows'
  | 'rowsPerPageOptions'
> & {
  classNames?: Partial<Record<TPaginationClasses, string>>;
};

const TPagination: React.FC<React.PropsWithChildren<PaginationProps>> = ({ classes, classNames, ...props }) => {
  const { t } = useTranslation();
  const { classes: paginationClasses } = useStyles();
  const showingTo =
    (props.page + 1) * props.rowsPerPage <= props.count ? (props.page + 1) * props.rowsPerPage : props.count;

  return (
    <TablePagination
      ActionsComponent={(p) =>
        props.rowsPerPage === -1 ? null : <TablePaginationActions {...p} className={classNames?.action} />
      }
      {...props}
      classes={{
        spacer: paginationClasses.paginationSpacer,
        selectLabel: classNames?.paginationCaption || paginationClasses.paginationCaption,
        displayedRows: classNames?.paginationCaption || paginationClasses.paginationCaption,
        toolbar: cx(classNames?.toolbar, paginationClasses.toolbar, classes?.toolbar),
        menuItem: classNames?.menuItem || paginationClasses.menuItem,
        select: classNames?.select,
      }}
      component="div"
      labelDisplayedRows={
        props.labelDisplayedRows
          ? props.labelDisplayedRows
          : () => `${props.page * props.rowsPerPage + 1}-${showingTo} of ${props.count}`
      }
      labelRowsPerPage={t('showing')}
      rowsPerPageOptions={props.rowsPerPageOptions}
      SelectProps={{
        className: props.rowsPerPageOptions
          ? classNames?.select || paginationClasses.select
          : paginationClasses.selectHidden,
      }}
      onPageChange={props.onPageChange}
      onRowsPerPageChange={props.onRowsPerPageChange}
    />
  );
};

export default TPagination;
